export const Products = ["FWSED", "TASK", "RISK", "AUDIT_CONTROL", "FINDING"];
export const ScopedProducts = [...Products];
